import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { Responsive } from '@/ui';

const videoOverlay = 'rgba(0, 0, 0, 0.4)';

export const HeaderWrapper = styled('div', { shouldForwardProp: isPropValid })<{
	backgroundImage: string;
	backgroundPosition?: string;
}>`
	background-size: cover;
	background-position: ${({ backgroundPosition = 'center' }) =>
		backgroundPosition};
	background-image: linear-gradient(180deg, #000 -9.52%, rgba(0, 0, 0, 0) 90%),
		url(${({ backgroundImage }) => backgroundImage});
`;

export const HeaderContentWrap = styled.div`
	display: flex;
	flex-direction: column;
	height: 500px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		height: 280px;
	}
`;

export const HeaderVideoOverlay = styled.div`
	&::after {
		content: '';
		position: absolute;
		left: 0;
		z-index: 0;
		height: 100vh;
		width: 100%;
		background-color: ${videoOverlay};
	}
`;
